//Add in Jquery 3 if needed, most plugins will use it.
window.$ = require('jquery');

//Add Jquery match height for elements
require('jquery-match-height');

//Need a Slick Carousel? Also comment out SCSS in Vendor if you dont need it.
require('slick-carousel');

//Want Greensock Animation?
//require('gsap');
//import ScrollToPlugin from '../../node_modules/gsap/src/uncompressed/plugins/ScrollToPlugin'

//Want Pushy Mobile Menu?
require('../../node_modules/@cmyee/pushy/js/pushy');

function initHomeSlider() {
    $(".hero_slide img").each(function () {
        var IMAGE = $(this);

        var MOBILE_IMAGE = IMAGE.data('mobile-image')
        var DESKTOP_IMAGE = IMAGE.data('desktop-image')

        if (MOBILE_IMAGE && $(window).width() < 500) {
            return IMAGE.attr('src', MOBILE_IMAGE)
        }

        IMAGE.attr('src', DESKTOP_IMAGE)
    });
}

$(document).ready(function ($) {

    if ($('.hero_slider').length > 0) {
        initHomeSlider();
        $(window).on('resize', initHomeSlider)

        $('.hero_slider').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            appendDots: '.vertical_dots'
        });
    }

    //Mobile Carousel
    $(document).ready(function ($) {
        //Sliders//
        $('.mobile_slider').slick({
            centerMode: true,
            centerPadding: '60px',
            slidesToShow: 3,
            responsive: [
                {
                    breakpoint: 480,
                    settings: {
                        arrows: false,
                        centerMode: true,
                        centerPadding: '40px',
                        slidesToShow: 3
                    }
                }
            ]
        });
    });

    //Mobile Carousel
    $(document).ready(function ($) {
        //Sliders//
        $('.mobile_slider_seasonal').slick({
            centerMode: false,
            centerPadding: '60px',
            slidesToShow: 1,
            responsive: [
                {
                    breakpoint: 480,
                    settings: {
                        arrows: false,
                        centerMode: true,
                        centerPadding: '40px',
                        slidesToShow: 1
                    }
                }
            ]
        });
    });

    $(document).ready(function () {
        $("#formButton").click(function () {
            $("#form1").toggle();
        });
    });

    $('#contact').click(function (event) {
        $('input:checkbox')[0].checked = false;
    });
    $('a[href*="#"]')
        .not('[href="#"]')
        .not('[href="#0"]')
        .click(function (event) {
            if (
                location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
                &&
                location.hostname == this.hostname
            ) {
                var target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                if (target.length) {
                    event.preventDefault();
                    $('html, body').animate({
                        scrollTop: target.offset().top
                    }, 1000, function () {
                    });
                }
            }
        });
});


$(".details").click(function () {
    $(this).closest('.column').children('.toggleState').slideToggle();
    if ($(this).text() == 'Details') {
        $(this).text('Hide Details');
    } else
        $(this).text('Details');
});


$(window).scroll(function () {
    if ($(window).scrollTop() >= 1)
        $('.wrapper').addClass('fixed_header');
    else
        $('.wrapper').removeClass('fixed_header');
});

$('a[href*="#"]')
    // Remove links that don't actually link to anything
    .not('[href="#"]')
    .not('[href="#0"]')
    .click(function (event) {
        // On-page links
        if (
            location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
            &&
            location.hostname == this.hostname
        ) {
            // Figure out element to scroll to
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            // Does a scroll target exist?
            if (target.length) {
                // Only prevent default if animation is actually gonna happen
                event.preventDefault();
                $('html, body').animate({
                    scrollTop: target.offset().top
                }, 1000, function () {
                    // Callback after animation
                    // Must change focus!
                    var $target = $(target);
                    $target.focus();
                    if ($target.is(":focus")) { // Checking if the target was focused
                        return false;
                    } else {
                        $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
                        $target.focus(); // Set focus again
                    };
                });
            }
        }
    });


// WEBPACK FOOTER //
// ./src/js/app.js